import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import StaffDashboard from "@/pages/StaffDashboard";
export const Route = createFileRoute("/staff")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><StaffDashboard /></ProtectedRoute>) });
